/**
 * The application's configured day.js.
 *
 * Import day.js from here, never from 'dayjs' directly: this module extends it
 * with the plugins the app relies on and sets the Finnish locale, so a file
 * that imports it cannot end up with an unconfigured instance.
 */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isBetween from 'dayjs/plugin/isBetween'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/fi'

dayjs.extend(utc)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(isBetween)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)

dayjs.locale('fi')

export default dayjs
